import { render } from "./Annuaire.vue?vue&type=template&id=0bd40a48"
import script from "./Annuaire.vue?vue&type=script&lang=js"
export * from "./Annuaire.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__